/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-named-as-default-member */
/**
 * #######################################################@
 *
 * Other settings
 *
 * #######################################################@
 */
import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";

import {
	Card,
	CardContent,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
	Icon
} from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import MDBox from "components/Basics/MDBox";
import MDButton from "components/Basics/MDButton";
import MDTypography from "components/Basics/MDTypography";
import { useState } from "react";
import i18n from "i18n";
import { display } from "redux-react/reducers/snackBarReducer";
import ProfileActions from "redux-react/actions/profileActions";
import RulesAction from "redux-react/actions/rulesActions";
import FormDictionary from "./Dictionary/FormDictionary";
import FormRule from "./Rule/FormRule";

const GetCorrectForm = ({ type, submit }) => {
	switch (type) {
		case "dictionary":
			return <FormDictionary submit={submit} />;
		case "rule": {
			return <FormRule submit={submit} />;
		}
		default:
			return <DialogContent>Not found</DialogContent>;
	}
};

const AddChartEnyity = ({ icon, text, type }) => {
	const [open, setOpen] = useState(false);
	const [isValid, setIsValid] = useState(false);
	const [datas, setDatas] = useState({});
	const dispatch = useDispatch();
	const profile = useSelector(selectCurrentProfile);

	const submit = ({ valid, data }) => {
		setDatas(data);
		setIsValid(valid);
	};

	const clickSubmit = () => {
		switch (type) {
			case "rule":
				dispatch(
					RulesAction.insertRule(
						profile.assistantID,
						datas,
						e => {
							dispatch(
								display({
									type: "success",
									message: i18n.t("SETTINGS.RULES.CALL.successCreate")
								})
							);
							dispatch(ProfileActions.updateMenu(profile.assistantID));
							setOpen(false);
						},
						e => {
							let message = e?.response?.data?.error?.message;
							dispatch(
								display({
									type: "error",
									message: i18n.t(`SETTINGS.RULES.CALL.${message || "errorCreate"}`)
								})
							);
						}
					)
				);
				break;
			default:
				break;
		}
	};

	return (
		<>
			<MDButton color="info" onClick={() => setOpen(true)}>
				<Icon>{icon}</Icon>&nbsp;{text}
			</MDButton>

			<Dialog fullWidth maxWidth="md" open={open} onClose={() => setOpen(false)}>
				<DialogContent>
					<GetCorrectForm type={type} submit={submit} />
				</DialogContent>
				<DialogActions>
					<MDButton variant="outlined" color="info" onClick={() => setOpen(false)}>
						{i18n.t("SETTINGS.cancel")}
					</MDButton>

					<MDButton variant="contained" color="info" onClick={clickSubmit} disabled={!isValid}>
						{i18n.t("SETTINGS.add")}
					</MDButton>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default function SettingsOthers({ route }) {
	return (
		<DashboardLayout>
			{/* <DashboardNavbar filters={[]} /> */}
			<Divider />
			<Card>
				<CardContent>
					<MDTypography>{i18n.t("SETTINGS.OTHERS.moreSettings")}</MDTypography>
					<MDBox display="flex" alignItems="center">
						{/* <MDBox m={1}>
							<AddChartEnyity icon="add" text="Ajouter une règle de gestion" type="rule" />
						</MDBox> */}
						<MDBox>
							<AddChartEnyity icon="add" text={i18n.t("SETTINGS.DICTIONARY.addRule")} type="rule" />
						</MDBox>
					</MDBox>
				</CardContent>
			</Card>
		</DashboardLayout>
	);
}
